import { onMounted, onUnmounted } from 'vue'
import { asyncTrack } from '@/track'

export function useTechAppHide() {
  let startTime = 0

  function handleVisibilityChange() {
    if (document.hidden) {
      startTime = performance.now()
    }
    else if (startTime > 0) {
      const duration = performance.now() - startTime
      asyncTrack('tech_app_hide', { duration: Math.floor(duration) })
      startTime = 0
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
}
